import axios from 'axios';
import { ProposalInput } from '../../../pages/proposal/form/input.interface';
import { getApiInstance } from '../api';

export const updateProposal = async ({
  token,
  proposalId,
  userInput,
}: {
  token: string;
  proposalId: string;
  userInput: ProposalInput;
}) => {
  const api = getApiInstance(token);
  try {
    await api.put(`/proposals/${proposalId}`, userInput);

    return { success: true };
  } catch (error) {
    console.error(error);

    if (axios.isAxiosError(error) && error.response?.status) {
      if (error.response?.status === 400) {
        const apiMessage = error?.response?.data?.message;
        const arrayOfMessages =
          typeof apiMessage === 'string' ? [apiMessage] : apiMessage || [];
        const message = [
          'Erro ao atualizar proposta.',
          ...arrayOfMessages,
        ].join(' ');
        return {
          success: false,
          message,
        };
      }
      return {
        success: false,
        message: `Erro ao atualizar proposta. ${error.response?.data.message}`,
      };
    }

    return {
      success: false,
      message: `Erro ao atualizar proposta. Erro desconhecido: ${
        (error as Error).message
      }`,
    };
  }
};
